import React from "react";
import { Box, Grid, makeStyles, Typography } from "@material-ui/core";
import { ShaDowBox } from "../../../../components/boxes";
import { NOIBarChart } from "../../../../components/charts";
import { TextInput } from "../../../../components/base";
import { COLORS } from "../../../../theme/colors";
import { NOIIconBox } from "../../NOIIconBox";

const useStyles = makeStyles((theme) => ({
  boxItem: {
    padding: `${theme.spacing(1.5)}px ${theme.spacing(2.5)}px ${theme.spacing(3.75)}px`,
  },
  boxItemInfo: {
    marginTop: theme.spacing(8),
    padding: `${theme.spacing(7)}px ${theme.spacing(1.25)}px ${theme.spacing(2.5)}px`,
    backgroundColor: COLORS.darks[0][6],
    position: "relative",
    minHeight: 154,
  },
  typographyValue: {
    color: COLORS.purple,
    fontWeight: 400,
  },
  boxItemRow: {
    "&:not(:last-child)": {
      marginBottom: 10,
    },
  },
  textInputContainerStyle: {
    margin: "0 5px",
  },
  textInputRootStyle: {
    border: `1px solid ${COLORS.darks[0][10]}`,
    borderRadius: 4,
    padding: 5,
    textAlign: "right",
    backgroundColor: COLORS.white,
  },
  rootStyle: {
    "& .MuiInput-underline::after": {
      borderBottom: 0,
    },
  },
  boxItemChart: {
    marginTop: theme.spacing(6),
  },
}));

const NOIBox = ({ item, filtervalue, handleChange }) => {
  const classes = useStyles();

  return (
    <Grid item sm={3} xs={12}>
      <ShaDowBox>
        <Box className={classes.boxItem}>
          <Typography variant="h4">{item.title}</Typography>
          <Box className={classes.boxItemInfo}>
            <NOIIconBox
              src={item.icon}
              rootStyle={{
                position: "absolute",
                top: "-40px",
                left: "50%",
                transform: "translateX(-50%)",
              }}
            />
            {item.rows.map((row, j) =>
              !j ? (
                <Grid container key={j} className={classes.boxItemRow} alignItems="center">
                  <Grid item xs={7}>
                    <Typography variant="body2">{row.label}</Typography>
                  </Grid>
                  <Grid
                    container
                    alignItems="center"
                    item
                    xs={5}
                    justifyContent="flex-end"
                    style={{ flexWrap: "nowrap" }}
                  >
                    {row.prefix ? <Typography>{row.prefix}</Typography> : null}
                    <TextInput
                      containerStyle={classes.textInputContainerStyle}
                      inputRootStyle={classes.textInputRootStyle}
                      rootStyle={classes.rootStyle}
                      value={filtervalue}
                      variant="standard"
                      onChange={(value) => handleChange(row.key, value)}
                    />
                    {row.suffix ? <Typography>{row.suffix}</Typography> : null}
                  </Grid>
                </Grid>
              ) : (
                <Grid container alignItems="center" className={classes.boxItemRow} key={j}>
                  <Grid item xs={7}>
                    <Typography variant="body2">{row.label}</Typography>
                  </Grid>
                  <Grid item xs={5}>
                    <Typography align="right" variant="h2" className={classes.typographyValue}>
                      {row.value}
                    </Typography>
                  </Grid>
                </Grid>
              )
            )}
          </Box>
          <Box className={classes.boxItemChart}>
            {item.chartData.data.length ? (
              <>
                <NOIBarChart
                  chartData={item.chartData}
                  defaultLabel={item?.defaultLabel}
                  height={100}
                  barSize={25}
                  bars={[
                    {
                      dataKey: item.chartData.fields[1]?.replaceAll(" ", "_"),
                      fill: COLORS.purple,
                      unit: item.chartData.unit,
                    },
                    {
                      dataKey: item.chartData.fields[0]?.replaceAll(" ", "_"),
                      fill: COLORS.grey,
                      unit: item.chartData.unit,
                    },
                  ]}
                />
              </>
            ) : null}
          </Box>
        </Box>
      </ShaDowBox>
    </Grid>
  );
};

export default NOIBox;
